var _defs, _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1520 1519.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#40afaa;stroke:#40afaa;}.cls-1,.cls-2{stroke-miterlimit:10;stroke-width:40px;}.cls-2{fill:none;stroke:#231f20;}.cls-3{fill:#231f20;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.18,
    y: 217.11,
    width: 1282.82,
    height: 1282.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20,
    y: 20,
    width: 1282.82,
    height: 1282.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M725.09,299.5v20l-33.86,3.08v312l33.86,3.59V658.7H605.53V638.17l34.9-3.59v-311h-1.54l-97,335.08H515.22L413.62,324.13h-1.54V634.58l31.81,3.59V658.7H354.61V638.17l29.25-3.59v-312l-29.25-3.08v-20H459.29l80.56,273h1.54l79-273Z",
    transform: "translate(10 9.96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M864.57,792.45c77,0,135,22.06,135,100.06,0,89.8-65.69,111.86-146.76,111.86H835.83v123.16l56.45,3.59v20.52H744.5v-20.52l39-3.59V816.05l-39-3.59v-20ZM835.83,980.77H857.9c59,0,84.16-28.74,84.16-85.7,0-58-25.66-79-81.59-79H835.83Z",
    transform: "translate(10 9.96)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e18784bc5a6aa53c093581e6b88069a4.svg";
export { ForwardRef as ReactComponent };